import instance from "../../utils/instance";

class DataService {
    async getList(metaId, sort, pageIndex, pageSize, accessControlPolicy, conditionGroups) {
        let sortDirection = sort.order === 'descending' ? 'DESC' : 'ASC';
        let encodedConditionGroups = encodeURI(JSON.stringify(conditionGroups));
        let url = `/dynamicentity/data/list?metaId=${metaId}&sortDirection=${sortDirection}&sortProperty=${sort.prop}&pageIndex=${pageIndex}&pageSize=${pageSize}&accessControlPolicy=${accessControlPolicy}&conditionGroups=${encodedConditionGroups}`;
        return instance.get(url);
    }

    async getDictionary(metaId, prop, keyword, accessControlPolicy) {
        let url = `/dynamicentity/data/dictionary?metaId=${metaId}&accessControlPolicy=${accessControlPolicy}&fieldName=${prop}&keyword=${keyword}`;
        return instance.get(url);
    }
}

export default new DataService();